/* This file controls theme navigation only. It never submits, clones, or tracks the app's forms. */
(() => {
 const config = document.getElementById('GRZLeadformConfig');
 if (!config) return;
 let data;
 try { data = JSON.parse(config.textContent); } catch { return; }
 const fallback = data.productUrl || data.cartUrl || data.productsUrl;
 function open(raw = fallback) {
  const target = new URL(raw || fallback, location.origin);
  const anchor = document.getElementById('GRZOrder');
  const requestedVariant = target.searchParams.get('variant');
  const selectedVariant = document.querySelector('section[id^="MainProduct-"] .product-variant-id')?.value;
  const sameVariant = !requestedVariant || !selectedVariant || requestedVariant === selectedVariant;
  if (anchor && target.origin === location.origin && target.pathname === location.pathname && sameVariant) {
   document.querySelector('cart-drawer')?.close?.();
   document.querySelectorAll('quick-add-modal[open]').forEach(modal => modal.hide?.(true));
   const current = new URL(location.href);
   current.hash = 'GRZOrder';
   history.replaceState(history.state, '', current.href);
   anchor.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start' });
   anchor.focus({ preventScroll:true });
   return;
  }
  location.assign(target.href);
 }
 function isCheckout(raw) {
  if (!raw) return false;
  try {
   const url = new URL(raw, location.origin);
   const shopHost = url.origin === location.origin || url.hostname.endsWith('.myshopify.com') || url.hostname === 'shop.app';
   return shopHost && (/\/(?:checkouts?|wallets\/checkouts?)(?:\/|$)/i.test(url.pathname) || /\/cart\/(?:c\/|\d+:)/i.test(url.pathname) || (/\/cart\/?$/.test(url.pathname) && url.searchParams.has('checkout')));
  } catch { return false; }
 }
 function orderTarget() { return data.productUrl ? data.productUrl + '#GRZOrder' : data.cartUrl + '#GRZCartOrder'; }
 // Remove known platform-checkout destinations even if a theme extension inserts one later.
 function cleanLinks(root) {
  if (!root.querySelectorAll) return;
  const links = [...root.querySelectorAll('a[href]')];
  if (root.matches?.('a[href]')) links.push(root);
  links.forEach(link => { if (isCheckout(link.getAttribute('href'))) { link.href = orderTarget(); link.dataset.grzLeadform = ''; } });
 }
 cleanLinks(document);
 new MutationObserver(records => records.forEach(record => {
  if (record.type === 'attributes') cleanLinks(record.target);
  else record.addedNodes.forEach(cleanLinks);
 })).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
 document.addEventListener('click', event => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest?.('a[data-grz-leadform],a[href="#GRZOrder"]');
  if (!link) return;
  event.preventDefault();
  open(link.href);
 });
 document.addEventListener('submit', event => {
  const form = event.target;
  // Scope to explicit theme controls and platform-checkout actions. Leadform's own form is untouched.
  const appForm = form.closest('.shopify-app-block,.leadform-form,#leadform-submit-form,#leadform-embedded-container');
  if (appForm) return;
  const checkout = isCheckout(form.getAttribute('action')) || event.submitter?.name === 'checkout';
  if (!checkout) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  open(orderTarget());
 }, true);
 window.GRZLeadform = Object.freeze({open});
})();
